import { render, staticRenderFns } from "./CompanyAvatar.vue?vue&type=template&id=5af71cf8&scoped=true&"
import script from "./CompanyAvatar.vue?vue&type=script&lang=js&"
export * from "./CompanyAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAvatar.vue?vue&type=style&index=0&id=5af71cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af71cf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
